import { useEffect } from "react";
import { SITE_URL } from "./config";

type PageMetadata = {
  title: string;
  description: string;
  path?: string;
  type?: "website" | "article";
};

function setMeta(selector: string, attribute: string, value: string) {
  let element = document.head.querySelector<HTMLMetaElement>(selector);
  if (!element) {
    element = document.createElement("meta");
    const [name, property] = attribute.split("=");
    element.setAttribute(name, property);
    document.head.appendChild(element);
  }
  element.setAttribute("content", value);
}

export function usePageMetadata({ title, description, path = "", type = "website" }: PageMetadata) {
  useEffect(() => {
    const canonicalUrl = `${SITE_URL}${path}`;
    document.title = title;
    setMeta('meta[name="description"]', "name=description", description);
    setMeta('meta[property="og:title"]', "property=og:title", title);
    setMeta('meta[property="og:description"]', "property=og:description", description);
    setMeta('meta[property="og:type"]', "property=og:type", type);
    setMeta('meta[property="og:url"]', "property=og:url", canonicalUrl);

    let canonical = document.head.querySelector<HTMLLinkElement>('link[rel="canonical"]');
    if (!canonical) {
      canonical = document.createElement("link");
      canonical.rel = "canonical";
      document.head.appendChild(canonical);
    }
    canonical.href = canonicalUrl;
  }, [description, path, title, type]);
}
